module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/17dHiMU/tc-custom/9781637158548.jpg?1695676356289",
      "alt": "This image is the cover for the book Dega Vol. 1, Dega"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Dega Vol. 1, Dega\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A crashed ship, a lone survivor, a monstrous secret hiding in the dark under the world. This is Dega, the new graphic novel from Doctor Who, Judge Dredd, and Firefly artist Dan McDaid. Written, illustrated, and lettered by McDaid, Dega delivers a stirring, unsettling blend of hardboiled sci-fi action, hypnagogic surrealism, and existential mystery. Hailed as \"electric... A title you have to read cover to cover and back to front\" by Richard Starkings (Elephantmen) and \"Beautiful... Valerian meets Ronin\" by mindlessones.com. The clues are all there, but hurry--time is running in...")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Dan McDaid\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("DAN MCDAID is a comics writer and artist based in Scotland. He started out writing and drawing adventures for the Tenth Doctor in Doctor Who Magazine, and he has since gone on to well-received runs on properties as diverse as Big Trouble in Little China, Judge Dredd and Firefly. Following acclaimed work on TKO’s pulp blockbuster “The Fearsome Dr Fang”, McDaid drew the swashbuckling horror Sea Dogs for Joe Hill's Hill House imprint and DC Comics. His most recent project is the self-published, self-penned title, the sci-fi mystery DEGA. He lives in a draughty old house with his partner and two dreadful cats.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Oni Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0